<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-5">
            <div class="form-group row">
              <div class="col-md-12 col-12">
                <yt-dropdown-picklist [ModelName]="'podvrstadokumentastavka'"
                                      [GetName]="'GetByUrl'"
                                      [ModelProperty]="'Sifra,Naziv'"
                                      [GetParameters]="modelData.MainList.GetParameters"
                                      formControlName="PodVrstaDokumentaStavkaID"
                                      [Label]="'TROSAKDOKUMENT.PODVRSTADOKUMENTASTAVKA.SINGULAR'"
                                      #autofocus
                                      [ngClass]="{'is-invalid': submitted && fc.PodVrstaDokumentaStavkaID.invalid}"
                                      (OnItemSelected)='onPodVrstaSelect()'
                                      [AutoSelect]="true"
                                      [AllowAddNew]="true"
                                      [Width]="'600px'"
                                      [Parameters]="parametersForPodvrstaDokumentStavka"
                                      (GetItems)="PodvrstaDokumentaGetItems($event)">
                </yt-dropdown-picklist>
                <div class="form-error" *ngIf="submitted && fc.PodVrstaDokumentaStavkaID.invalid">
                  <span *ngFor="let validation of errorMessages.PodVrstaDokumentaStavkaID">
                    <span class="error-message" *ngIf="fc.PodVrstaDokumentaStavkaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- Datum dokumenta -->
          <div class="col-md-3 col-12">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup formControlName="Datum"
                                         name="txtDaNal"
                                         [Label]="'TROSAKDOKUMENT.DATUM.SINGULAR'"
                                         [ngClass]="{'is-invalid': submitted && fc.Datum.invalid}"
                                         (OnDateSelected)="onDatumChange($event)">
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
                  <span *ngFor="let validation of errorMessages.Datum">
                    <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- Broj dokumenta -->
          <div class="col-md-4 col-12">
            <div class="form-group row">
              <div class="col-md-8 col-8">
                <yt-input [Type]="'text'"
                          [Label]="'TROSAKDOKUMENT.BROJDOKUMENTA.SINGULAR'"
                          formControlName="Broj"
                          [ngClass]="{'is-invalid': submitted && fc.Broj.invalid}">
                </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Broj.invalid">
                  <span *ngFor="let validation of errorMessages.Broj">
                    <span class="error-message" *ngIf="fc.Broj.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
              </div>
              <div class="col-md-4 col-4">
                <div class="input-group-append">
                  <span class="span-control">/</span><span *ngIf="baseFormGroup.get('Datum').value != null" class="span-control">{{baseFormGroup.get('Datum').value.year}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Komitent, brfak, datfak, datdpo -->
        <div class="row">
          <div class="col-md-12 col-6">
            <div class="form-group row">
              <div class="col-md-4 col-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-dropdown-picklist [ModelName]="'komitent'"
                                          [GetName]="'get'"
                                          [ModelProperty]="'SNaziv,Mesto'"
                                          [OrderBy]="'SNaziv'"
                                          [AllowAddNew]="true"
                                          [AllowEdit]="true"
                                          formControlName="KomitentID"
                                          [Label]="'TROSAKDOKUMENT.KOMITENT.SINGULAR'"
                                          [Width]="'xl'">
                    </yt-dropdown-picklist>
                    <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
                      <span *ngFor="let validation of errorMessages.KomitentID">
                        <span class="error-message" *ngIf="fc.KomitentID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'"
                              [Label]="'TROSAKDOKUMENT.BROJFAKTURE.SINGULAR'"
                              formControlName="BrojFakture">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.BrojFakture.invalid">
                      <span *ngFor="let validation of errorMessages.BrojFakture">
                        <span class="error-message" *ngIf="fc.BrojFakture.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group row">
                  <div class="col-md-12 col-6">
                    <yt-fw-date-picker-popup formControlName="DatumFakture"
                                             name="txtDatfak"
                                             [Label]="'TROSAKDOKUMENT.DATUMFAKTURE.SINGULAR'">
                    </yt-fw-date-picker-popup>
                    <div class="form-error" *ngIf="submitted && fc.DatumFakture.invalid">
                      <span *ngFor="let validation of errorMessages.DatumFakture">
                        <span class="error-message" *ngIf="fc.DatumFakture.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group row">
                  <div class="col-md-12 col-6">
                    <yt-fw-date-picker-popup formControlName="DatDpo"
                                             name="txtDatdpo"
                                             [Label]="'TROSAKDOKUMENT.DATDPO.SINGULAR'">
                    </yt-fw-date-picker-popup>
                    <div class="form-error" *ngIf="submitted && fc.DatDpo.invalid">
                      <span *ngFor="let validation of errorMessages.DatDpo">
                        <span class="error-message" *ngIf="fc.DatDpo.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                    <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                      <span class="error-message" *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlsDpo && !this.baseFormGroup.errors.checkControlsDpo.valid"><span translate="{{this.baseFormGroup.errors.checkControlsDpo.message}}"></span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Kraj komitent, brfak, datfak, datpdo -->
        <!-- Model, Poziv na broj odobrenja -->
        <div class="row">
          <div class="col-md-12 col-6">
            <div class="form-group row">
              <div class="col-md-2 col-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'"
                              [Label]="'TROSAKDOKUMENT.MODEL.SINGULAR'"
                              formControlName="Model">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.Model.invalid">
                      <span *ngFor="let validation of errorMessages.Model">
                        <span class="error-message" *ngIf="fc.Model.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'"
                              [Label]="'TROSAKDOKUMENT.POZIVBROJODOBRENJA.SINGULAR'"
                              formControlName="PozivBrojOdobrenja">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.PozivBrojOdobrenja.invalid">
                      <span *ngFor="let validation of errorMessages.PozivBrojOdobrenja">
                        <span class="error-message" *ngIf="fc.PozivBrojOdobrenja.hasError(validation.type)">
                          <span translate="{{validation.message}}"></span>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'"
                              [Label]="'TROSAKDOKUMENT.DELOVODNIBROJ.SINGULAR'"
                              formControlName="DelovodniBroj">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.DelovodniBroj.invalid">
                      <span *ngFor="let validation of errorMessages.DelovodniBroj">
                        <span class="error-message" *ngIf="fc.DelovodniBroj.hasError(validation.type)">
                          <span translate="{{validation.message}}"></span>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <!-- Kraj komitent, brfak, datfak, datpdo -->
        <!-- Pdv viša, niža, pdv viša bez prava odbitka, niža bez prava odbitka -->
        <div class="row" *ngIf='false'>
          <div class="col-md-3 col-3">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-number-input-v3 name="txtPdvVisa"
                                    formControlName="PdvVisa"
                                    [Label]="'TROSAKDOKUMENT.PDVVISA.SINGULAR'">
                </yt-number-input-v3>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-3">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-number-input-v3 name="txtPdvNiza"
                                    formControlName="PdvNiza"
                                    [Label]="'TROSAKDOKUMENT.PDVNIZA.SINGULAR'">
                </yt-number-input-v3>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-3">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-number-input-v3 name="txtPdvVisaBezOdbit"
                                    formControlName="PdvVisaBezOdbit"
                                    [Label]="'TROSAKDOKUMENT.PDVVISABEZODBIT.SINGULAR'">
                </yt-number-input-v3>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-3">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-number-input-v3 name="txtPdvNizaBezOdbit"
                                    formControlName="PdvNizaBezOdbit"
                                    [Label]="'TROSAKDOKUMENT.PDVNIZABEZODBIT.SINGULAR'">
                </yt-number-input-v3>
              </div>
            </div>
          </div>
        </div>
        <!-- Kraj Pdv viša, niža, pdv viša bez prava odbitka, niža bez prava odbitka -->
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-12">
        <div class="btn-group float-right">
          <button type="button" class="btn btn-outline-primary" (click)="SaveItem()" [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable"><span class="fa fa-fa fa-save"></span> Sačuvaj</button>
          <button type="button" class="btn btn-outline-primary" (click)="onRestoreClick()" [disabled]="saveDisabled"><span class="fa fa-fa fa-undo"></span> Odustani</button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <yt-trosak-dokument-stavka-update-container #baseInlineContainer
                                                    [DetailModelData]="modelData.MainList.DetailList[0]"
                                                    [ParentPropertyName]="'TrosakDokumentID'"
                                                    [ParentPropertyValue]="Item.ID"
                                                    [Parameters]="TransferParameters">
        </yt-trosak-dokument-stavka-update-container>
      </div>
    </div>
  </form>
</div>
